import 'leaflet-velocity'
import L from 'leaflet'
import React, { useState } from 'react'
import { useLeafletContext } from '@react-leaflet/core'
import PropTypes from 'prop-types'

const WindLayer = ({
    displayValues,
    displayOptions,
    data,
    minVelocity,
    maxVelocity,
    colorScale,
    opacity,
}) => {
    const [layer, setLayer] = useState(null)
    const context = useLeafletContext()
    React.useEffect(() => {
        const layer = L.velocityLayer({
            displayValues: displayValues,
            displayOptions,
            colorScale,
            data,
            minVelocity,
            maxVelocity,
            
            opacity,
        })
        const container = context.layerContainer || context.map
        container.addLayer(layer)
        setLayer(layer)
    }, [])

    React.useEffect(() => {
        if (layer && data) {
            layer.setData(data)
        }
        return
    }, [data])

    return null
}

export default WindLayer

WindLayer.propTypes = {
    displayValues: PropTypes.bool,
    displayOptions: PropTypes.object,
    data: PropTypes.array,
    minVelocity: PropTypes.number,
    maxVelocity: PropTypes.number,
    opacity: PropTypes.number,
    colorScale: PropTypes.array,
}
